export default "__VITE_ASSET__COdf9rIX__"